import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../mutation-types';
import stockistApi from '../../../api/stockist';
import bank from '../../../api/bank';
import transaksi from '../../../api/transaction';
import alertHelper from '../../../helpers/alert';

const defaultState = () => ({
    bank: {},
    stockist: {},
    step1: {
        starterkit: 0,
        water_ro: 0,
        water: 0,
        sponsor: '',
        nama: '',
        email: '',
        phone: '',
        username: '',
        password: '',
    },
    step2: {
        datePickup: '',
        receiverName: '',
        province_id: '',
        city_id: '',
        district_id: '',
        address: '',
        zipcode: '',
        shipping_name: '',
        shipping_service: '',
        shipping_price: 0,
    },
    orderData:{
    },
});

const state = defaultState();

const mutations = {
    reset(state) {
		Object.assign(state, defaultState());
	},
    failed(state, { code, type, message }) {
        state.alerts = alertHelper.make(state.alerts, code, type, message);
    },
    removeAlert(state, id) {
        const index = Array.from(state.alerts).findIndex(it => it.id === id);

        if (index !== -1) {
            state.alerts.splice(index, 1);
        }
    },
    dataBank(state, data) {
        state.bank = Object.assign({}, state.bank, data);
    },
    saveOrderData(state, data) {
        state.orderData = Object.assign({}, state.orderData, data);
    },
};

const actions = {
    postPickup({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        if(!value.member){
            transaksi.pickupPublic(value.params).then(({ data: { data } }) => {
                commit('saveOrderData', data);
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                const { data } = err.response;
                const { error } = err.response.data;
                if(error.message == 'error_validation'){
                    commit('Step3Eror', error.data);
                    commit('Step3ErorTittle', error.message);
                } else {
                    commit('Step3ErorTittle', error.message);
                }
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
        } else {
            transaksi.pickupMember(value.params).then(({ data: { data } }) => {
                commit('saveOrderData', data);
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                const { data } = err.response;
                const { error } = err.response.data;
                if(error.message == 'error_validation'){
                    commit('Step3Eror', error.data);
                    commit('Step3ErorTittle', error.message);
                } else {
                    commit('Step3ErorTittle', error.message);
                }
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
        }
    },
    postShipping({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        if(!value.member){
            transaksi.shippingPublic(value.params).then(({ data: { data } }) => {
                commit('saveOrderData', data);
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                const { data } = err.response;
                const { error } = err.response.data;
                if(error.message == 'error_validation'){
                    commit('Step3Eror', error.data);
                    commit('Step3ErorTittle', error.message);
                } else {
                    commit('Step3ErorTittle', error.message);
                }
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
        } else {
            transaksi.shippingMember(value.params).then(({ data: { data } }) => {
                commit('saveOrderData', data);
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                const { data } = err.response;
                const { error } = err.response.data;
                if(error.message == 'error_validation'){
                    commit('Step3Eror', error.data);
                    commit('Step3ErorTittle', error.message);
                } else {
                    commit('Step3ErorTittle', error.message);
                }
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
        }

    },
    getBankAccount({ commit, dispatch }) {
        commit(PROGRESS_START, null, { root: true });
        bank.bankAccount().then(({ data: { data: { results } } }) => {
            commit('dataBank', results);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getReview({ state, commit, dispatch }, code) {
        if (code === state.stockist.stockist_code) {
            return;
        }

        commit(PROGRESS_START, null, { root: true });
        stockistApi.review(code).then(({ data: { data } }) => {
            commit('reviewRequestSuccess', data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    errorHandler({ commit }, response) {
        commit('failed', { code: 'error_response', type: 'error', message: response.message });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
